import { modifyDevice as modifyDeviceService } from 'services/api/device/modify';
import { rentHistoryModifyDeviceSuccess } from 'action-creators/payway/rentHistory/actionTypes';
import Metrics from 'services/metrics';
import * as constants from './constants';

const modifyDevice = payload => async dispatch => {
  Metrics.newEvent({
    eventCategory: 'Dispositivos',
    eventAction: payload.deviceCategory,
    eventLabel: 'Editar - Guardar',
  });
  dispatch({ type: constants.MODIFY, payload });
  const { deviceId, deviceName } = payload;
  try {
    await modifyDeviceService({ device_id: deviceId, device_name: deviceName });
    dispatch(modifyDeviceSuccess({ deviceId, deviceName }));
  } catch (error) {
    dispatch(modifyDeviceFail({ error }));
  }
};

const modifyDeviceByContent = payload => async dispatch => {
  dispatch({ type: constants.MODIFY, payload });
  const { deviceId, deviceName, purchaseId } = payload;
  try {
    await modifyDeviceService({
      device_id: deviceId,
      device_name: deviceName,
      id_pago: purchaseId,
    });
    dispatch(modifyDeviceSuccess(payload));
    dispatch(rentHistoryModifyDeviceSuccess(payload));
  } catch (error) {
    dispatch(modifyDeviceFail({ error }));
  }
};

const modifyDeviceSuccess = payload => dispatch => {
  dispatch({ type: constants.MODIFY_SUCCEEDED, payload });
};

const modifyDeviceFail = payload => dispatch => {
  dispatch({ type: constants.MODIFY_FAILED, payload });
};

export {
  // action creators
  modifyDevice,
  modifyDeviceByContent,
  modifyDeviceSuccess,
  modifyDeviceFail,
};
